import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import PropTypes from 'prop-types';
import { Button, ProgressBar, OptionsField, SelectClinic, DateAndTime, UpcomingAppointmentWidget, SignUpForm, BillingForm } from 'components';
import ScheduleConsultSteps, { SCREEN_TYPES } from 'data/scheduleConsult';
import appointments from 'data/appointments';
import './styles.css';
import { isEmailValid, isPasswordValid, isPasswordMatch, isInputValid, isPhoneNumberValid, isDOBValid, isDateValid, isCardValid } from '../../utilities/validation';
import { showErrorToast } from '../../utilities/notificationUtils';
import { location, appointment } from '../../assets/icons';

// These need to match the transition values in the styles.scss
const FADE_IN_TIME = 500;
const FADE_OUT_TIME = 300;

export default class ScheduleConsult extends Component {
  constructor(props) {
    super(props);

    const fields = ScheduleConsultSteps.reduce((accumulator, currentValue) => {
      if (currentValue.field) {
        accumulator[currentValue.field] = null;
      }

      if (currentValue.fields) {
        if (currentValue.type === SCREEN_TYPES.USER_SIGN_UP) {
          accumulator["userInfo"] = {}
          accumulator["accountInfo"] = {}
          currentValue.fields.forEach((field) => {
            if (
              field.field === "email" ||
              field.field === "password" ||
              field.field === "confirmPassword" ||
              field.field === "communicationConsent"
            ) {
              accumulator["accountInfo"][field.field] = { label: "", value: "" };
            } else {
              accumulator["userInfo"][field.field] = { label: "", value: "" };
            }
          })
        } else if (currentValue.type === SCREEN_TYPES.BILLING) {
          accumulator["cardInfo"] = {}
          currentValue.fields.forEach((field) => {
            accumulator["cardInfo"][field.field] = { label: field.label, value: "" };
          })
        }
      }

      return accumulator
    }, {});

    this.state = {
      step: 0,
      totalSteps: ScheduleConsultSteps.length,
      errors: [],
      ...fields
    };

    this.fetchLocations();
  }

  // LIFE CYCLE METHODS ------------------------------------------------------------------------ 

  componentWillMount() {
    this.scrollToTop();
  }

  render() {
    const { step, totalSteps } = this.state;
    const currentStep = ScheduleConsultSteps[step];
    let consultType = this.state.consultType !== null ? this.state.consultType.value : ""
    let header;
    if (currentStep) {
      switch (step + 1) {
        case ScheduleConsultSteps.length:
          consultType !== "Phone Consultation" ? header = currentStep.heading + " See you soon." : header = currentStep.heading + " Talk with you soon.";
          break;
        default:
          header = currentStep.heading;
          break;
      }
    }

    return (
      <div className="consult">
        <ReactCSSTransitionGroup
          transitionName="fade-in"
          component="div"
          className="consult__question"
          transitionAppear={true}
          transitionAppearTimeout={FADE_IN_TIME}
          transitionEnter={false}
          transitionLeave={true}
          transitionLeaveTimeout={FADE_OUT_TIME}>
          {currentStep && (
            <div className="consult__question--animated">
              {
                currentStep.heading && (
                  <div className="h2 consult__heading">{header}</div>
                )
              }
              {
                currentStep.type && (
                  this.renderStep(currentStep)
                )
              }
              {
                currentStep.lower && (
                  <div className="consult__lower h3">{currentStep.lower}</div>
                )
              }
              {
                currentStep.button && (
                  <Button
                    label={currentStep.button}
                    onClick={() => this.handleButtonClick(currentStep)}
                  />
                )
              }
            </div>
          )}
        </ReactCSSTransitionGroup>
        <ProgressBar
          step={step !== null ? step + 1 : null}
          total={totalSteps}
          onBack={this.handleBackPress}
          onFinishLater={null}
        />
      </div>
    );
  }

  // TEMPLATING METHODS ----------------------------------------------

  renderStep = (stepData) => {
    if (!stepData) {
      return null;
    }
    switch (stepData.type) {
      case SCREEN_TYPES.OPTION:
        return (
          <OptionsField
            options={stepData.options}
            selected={this.state[stepData.field]}
            onSelect={(value) => this.handleChange(stepData.field, value)}
          />
        );
      case SCREEN_TYPES.SELECT_LOCATION:
        return (
          <SelectClinic
            clinics={this.props.locations}
            selected={this.state[stepData.field]}
            onSelect={(value) => this.handleChange(stepData.field, value)}
          />
        );
      case SCREEN_TYPES.DATE_AND_TIME:
        return (
          <DateAndTime
            location={this.state.location && this.state.location.name}
            appointments={appointments}
            selected={this.state[stepData.field]}
            onSelect={(value) => this.handleChange(stepData.field, value)}
          />
        );
      case SCREEN_TYPES.MESSAGE:
        return (
          <UpcomingAppointmentWidget
            location={this.state.location !== null ? this.state.location.name : ""}
            address={this.state.location !== null ? this.state.location.address : {}}
            phone={this.state.userInfo.phone !== null ? this.state.userInfo.phone.value : ""}
            type={this.state.consultType.value}
            date={Date.now()}
          />
        );
      case SCREEN_TYPES.USER_SIGN_UP:
        return (
          <SignUpForm
            fields={stepData.fields}
            handleInput={this.handleInput.bind(this)}
            handleChange={this.handleChange.bind(this)}
            accountInfo={this.state.accountInfo}
            userInfo={this.state.userInfo}
            errors={this.state.errors}
          />
        );
      case SCREEN_TYPES.BILLING:
        let { price, message, app } = ""
        let name = this.state.userInfo.firstName.value
        switch (this.state.consultType.value) {
          case "Fertility Assessment":
            price = "$299"
            message = "seeing you soon"
            app = this.state.location
            break;
          case "Phone Consultation":
            price = "$29"
            message = "speaking with you soon"
            app = this.state.userInfo.phone.value
            break;
          default:
            break;
        }
        return (
          <React.Fragment>
            <div className="appointment__summary">
              <span className="appointment__summary__subheader">
                We look forward to {message}, <strong>{name}</strong>.
               </span>
              <span className="appointment__summary__subheader">
                Please review your selection and add payment details.
              </span>
              <div className="appointment__summary__widget">
                <span className="appointment__summary__price">
                  {this.state.consultType.value} {price}
                </span>
                {
                  this.state.consultType.value === "Fertility Assessment" ?
                    (
                      <React.Fragment>
                        <img src={location} alt="location icon" />
                        <span className="appointment__summary__details">
                          {app.address.street}
                        </span>
                        <span className="appointment__summary__details">
                          {app.address.street2}
                        </span>
                        <span className="appointment__summary__details">
                          {app.address.city}, {app.address.state}
                        </span>
                        <span className="appointment__summary__details">
                          {app.address.zip}
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <img src={appointment} alt="appointment icon" />
                        <span className="appointment__summary__details">
                          Tel : {app}
                        </span>
                      </React.Fragment>
                    )
                }
              </div>
            </div>

            <BillingForm
              fields={stepData.fields}
              handleInput={this.handleInput.bind(this)}
              cardInfo={this.state.cardInfo}
              errors={this.state.errors}
            />
          </React.Fragment>
        )
      default:
        return null;
    }
  }

  //  CUSTOM METHODS ---------------------------------------------------
  fetchLocations = async () => {
    try {
      await this.props.getLocations();
    } catch (error) {
      console.log(error);
    }
  }

  // TODO: Additional logic for how an appointment will be saved
  holdAppointment = async () => {
    try {
      await this.props.holdAppointment();
    } catch (error) {
      console.log(error);
    }
  }

  // TODO:  Should previously question reset when going back?
  handleBackPress = () => {
    let previous = this.state.step - 1
    if (this.state.step === 0) this.props.redirectToHome();
    if (ScheduleConsultSteps[this.state.step].field === "appointment" && this.state.consultType.value === "Phone Consultation") previous = 1;
    if (previous < 0) previous = 0;

    this.transitionToStep(previous);
  }

  handleChange = async (field, value) => {
    this.setState({ [field]: value });
    const currentStep = ScheduleConsultSteps[this.state.step];

    if (currentStep.type === SCREEN_TYPES.DATE_AND_TIME) {
      await this.holdAppointment();
    } else if (currentStep.type === SCREEN_TYPES.DATE_FIELD || currentStep.type === SCREEN_TYPES.TEXT_INPUT) {
      return;
    }

    if (field === "consultType" && value.value === "Phone Consultation") {
      this.transitionToStep(this.state.step + 2);
    } else {
      this.transitionToStep(this.state.step + 1);
    }
  }

  // TODO: Make API request to create user 
  handleButtonClick = (stepData) => {
    switch (stepData.type) {
      case "USER_SIGN_UP":
        this.validate()
        break;
      case "BOOK_APPOINTMENT":
        // TODO: make api request book appointment
        this.transitionToStep(this.state.step + 1);
        break;
      case "BILLING":
        this.validateBilling();
        break;
      case "MESSAGE":
        this.login()
        break;
      default:
        this.transitionToStep(this.state.step + 1);
        break;
    }
  }

  handleInput = (type, field, value) => {
    let newState = this.state[type]
    newState[field] = {
      label: field,
      value: value
    }
    this.setState({ [type]: newState })
  }

  // Set step to null to trigger fade out, then set correct step
  transitionToStep = (step) => {
    if (step !== this.state.step) {
      this.setState({ step: null });
      setTimeout(() => {
        this.setState({ step: step }, this.scrollToTop);
      }, FADE_OUT_TIME);
    }
  }

  scrollToTop = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  validateBilling = () => {
    let { cardInfo, step } = this.state;
    let warnings = [];
    let errors = isCardValid(cardInfo);

    if(!cardInfo.membershipTerms.value) {
      errors.push("membershipTerms");
      warnings.push("Membership Terms");
    } 

    if(errors.length) {
      this.setState({ errors: errors })
      errors.forEach((err) => { err !== "membershipTerms" ? warnings.push(` ${cardInfo[err].label}`): null });
    }

    switch(errors.length) {
      case 0: 
        this.setState({ errors: []}, function() {
          this.transitionToStep(step + 1);
        })
        break;
      case 1:
        showErrorToast(`Please fix the following required field: ${warnings}`)
        break; 
      default:
        showErrorToast(`Please fix the following required fields: ${warnings}`)
      break;
    }
  }

  validate = () => {
    this.setState({ errors: [] }, () => {
      let errors = this.state.errors
      let toasts = [];
      let accountInputs = Object.keys(this.state.accountInfo).map((val) => val)
      let userInputs = Object.keys(this.state.userInfo).map((val) => val)

      // Check user info for errors
      userInputs.forEach((input) => {
        let err;
        switch (input) {
          case "firstName":
            err = " First Name"
            break;
          case "lastName":
            err = " Last Name"
            break;
          case "gender":
            err = " Gender"
            break;
          case "birthdate":
            err = " Birthdate"
            break;
          case "phone":
            err = " Phone Number"
            break;
          default:
            break;
        }
        if (!isInputValid(this.state.userInfo[input].value) && !errors.includes(input)) {
          errors.push(input)
          toasts.includes(err) ? null : toasts.push(err)
        }
        if (input === "phone" && !isPhoneNumberValid(this.state.userInfo[input].value)) {
          errors.push(input)
          toasts.includes(err) ? null : toasts.push(err)
        }
        if (input === "birthdate" && !isDOBValid(this.state.userInfo[input].value)) {
          errors.push(input)
          toasts.includes(err) ? null : toasts.push(err)

        }
        this.setState({ errors: errors })
      })

      // Check account info for errors
      accountInputs.forEach((input) => {
        let err;
        switch (input) {
          case "email":
            err = " Email"
            if (input === "email" && !isEmailValid(this.state.accountInfo[input].value)) {
              errors.push(input)
              toasts.push(err)
            }
            break;
          case "password":
            err = " Password"
            if (input === "password") {
              if (!isPasswordValid(this.state.accountInfo[input].value)) {
                errors.push(input)
                toasts.includes(err) ? null : toasts.push(err)
              }
            }
            break;
          case "confirmPassword":
            err = " Cofirm Password"
            if (input === "confirmPassword") {
              if (this.state.accountInfo[input].value === "") {
                errors.push(input)
                toasts.includes(err) ? null : toasts.push(err)
              }
              if (!isPasswordMatch(this.state.accountInfo["password"].value, this.state.accountInfo[input].value)) {
                errors.push(input, "password")
                toasts.includes(err) ? null : toasts.push(err)
              }
            }
            break;
          default:
            break;
        }
        this.setState({ errors: errors })
      })

      // Show toasts
      let errorsLength = errors.length
      let state = this.state
      let message = `Please fix the following fields: ${toasts}`
      switch (errorsLength) {
        case 0:
          this.transitionToStep(state.step + 1)
          break;
        case 1:
          message = `Please fix the following field: ${toasts}`
          errors.includes("email") ? message = "Please enter a valid email." : null
          errors.includes("password") ? message = "Please enter a password with a minimum length of 6 characters." : null
          errors.includes("birthdate") ? isDateValid(state.userInfo.birthdate.value) ? message = "Patients must be 18 years or older to schedule a consult." : message = "Please enter a valid date." : null

          showErrorToast(message)
          break;
        case 2:
          message = `Please fix the following fields: ${toasts}`
          errors.includes("password", "confirmPassword") && !isPasswordMatch(state.accountInfo['password'].value, state.accountInfo['confirmPassword'].value) ? message = "Passwords do not match" : null
          showErrorToast(message)
          break;
        default:
          showErrorToast(message)
          break;
      }
    })
  }

  login = async () => {
    const { errors } = this.state;
    let email = this.state.accountInfo.email.value;
    let password = this.state.accountInfo.password.value;

    if (!errors.length) {
      try {
        await this.props.login(email.trim(), password.trim()).then(() => {
          return this.props.redirectToHome();
        })
      } catch (error) {
        console.log(error);
      }
    } else {
      showErrorToast("Sorry something went wrong. Please try again later.");
      this.props.redirectToHome();
    }
  }

  //  PROPTYPES ---------------------------------------------------
  static propTypes = {
    locations: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        address: PropTypes.shape({
          street: PropTypes.string.isRequired,
          street2: PropTypes.string.isRequired,
          city: PropTypes.string.isRequired,
          state: PropTypes.string.isRequired,
          zip: PropTypes.string.isRequired,
        }).isRequired
      })
    ),
    getLocations: PropTypes.func.isRequired,
    holdAppointment: PropTypes.func.isRequired
  }

  static defaultProps = {
    locations: []
  }
}




// WEBPACK FOOTER //
// ./src/screens/ScheduleConsult/ScheduleConsult.js